import { TaskCardType } from '@/task-manager/entities/task-card-type';
import {
  type AlertInfoPreview,
  type TaskPreview,
} from '@/task-manager/entities/task-preview';
import { UnreachableCaseError } from '@/utils/errors/unreachable-case-error';

import type { ListCardsViewOutputExistingCards } from '../fetch-client';

import { alertStatusMapper } from './alert-status';
import { alertTypeMapper } from './alert-type';
import { taskPriorityMapper } from './task-priority';
import { taskProjectManagementMapper } from './task-project-management';
import { taskStatusMapper } from './task-status';

export function taskPreviewMapper(
  data: ListCardsViewOutputExistingCards,
): TaskPreview {
  const base: Omit<TaskPreview, 'cardType'> = {
    id: data.uuid,
    title: data.title,
    subtitle: data.subtitle,
    priority: taskPriorityMapper(data.priority),
    status: taskStatusMapper(data.status),
  };

  switch (data.card_type) {
    case 'Standard': {
      return {
        ...base,
        cardType: TaskCardType.STANDARD,
        projectManagement: taskProjectManagementMapper(
          data.workstream_project_details,
        ),
      };
    }
    case 'Alert': {
      return {
        ...base,
        cardType: TaskCardType.ALERT,
        alert: alertInfoPreviewMapper(data),
      };
    }
    case 'DataOnboardingIncident': {
      return { ...base, cardType: TaskCardType.DATA_ONBOARDING_INCIDENT };
    }
    default: {
      throw new UnreachableCaseError(data.card_type);
    }
  }
}

export function alertInfoPreviewMapper(
  data: ListCardsViewOutputExistingCards,
): AlertInfoPreview {
  return {
    status: data.alert_status
      ? alertStatusMapper(data.alert_status)
      : undefined,
    type: alertTypeMapper(data.alert_type),
    suggestedAction: data.suggested_action ?? '',
    resolved: Boolean(data.resolved),
  };
}
